import { Text, View, Link } from '@react-pdf/renderer';
import { BLOCK_EXPLORER_TXN_ID_URL } from '../../utils/config';
import { infoBoxes } from '../../styles/pdfStyles/infoBoxStyles';

const NftSectionPDF = ({ reportData }) => {
  return (
    <View style={infoBoxes.container}>
      <Text style={infoBoxes.title}>NFT Proof</Text>

      <View style={[infoBoxes.section, { flexDirection: 'row' }]}>
        <Text style={[infoBoxes.label, { fontWeight: 'bold', width: 140 }]}>Token ID: </Text>
        <Text style={infoBoxes.value}>{reportData.TOKEN_ID}</Text>
      </View>

      <View style={[infoBoxes.section, { flexDirection: 'row' }]}>
        <Text style={[infoBoxes.label, { fontWeight: 'bold', width: 140 }]}>Link to NFT: </Text>
        {/*  TODO change styling */}
        <Link style={infoBoxes.link} src={`${BLOCK_EXPLORER_TXN_ID_URL}/${reportData.TOKEN_TXPOW}`}>
          Minima Explorer
        </Link>
      </View>
    </View>
  );
};

export default NftSectionPDF;
